module.exports = __webpack_public_path__ + "img/banner-coupon.77f9ae66.jpg";